import React, {useEffect, useState} from "react";
import {BASE_URL} from "../utils/commonUrl";
import Layout from "../components/Layout";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import UserRoleNamesForm from "./forms/UserRoleNamesForm";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {fetchUserRoleName} from "../redux/features/userRoleNames.feature";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const UserRoleNames = () => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state["userRoleName"]);
    const [modal, setModal] = useState(false);
    const [start] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [activeUserRole, setActiveUserRole] = useState([]);
    const [designationNames, setdesignationNames] = useState([]);
    const [userRoleNamesItem, setUserRoleNamesItem] = useState({
        userRoleNameID: 0,
        userRoleID: 0,
        designationID: 0,
        roleTitle: "NA",
        active: true,
    });

    useEffect(() => {
        userRoles();
        userDesignation();
        initFilters1();
        dispatch(fetchUserRoleName());
    }, []);

    const userRoles = async () => {
        try {
            const url = BASE_URL + '/api/userRole/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const userRoles = [{value: '-1', label: 'Please Select Role'}];
                response.data.map(val => userRoles.push({value: val.userRoleID, label: val.roleName}))

                setActiveUserRole(userRoles)
            }

        } catch (e) {
            console.log(e)
        }
    }
    
    const userDesignation = async () => {
        try {
            const url = BASE_URL + '/api/utility/GetAllDesignation'
            const response = await axios.get(url)
            if (response.status === 200) {
                const userDesignation = [{value: '-1', label: 'Please Select Designation'}];
                response.data.map(val => userDesignation.push({value: val.designationID, label: val.designation}))

                setdesignationNames(userDesignation)
            }

        } catch (e) {
            console.log(e)
        }

    }
    const onSubmit = async (data) => {
        try {
            setIsLoading(true);
            const url = BASE_URL + "/api/userRoleName";
            const response = await axios.post(url, data);
            setIsLoading(false);
            if (response.status === 200) {
                dispatch(fetchUserRoleName());
                setUserRoleNamesItem({
                    userRoleNameID: 0,
                    userRoleID: 0,
                    designationID: 0,
                    roleTitle: "NA",
                    active: true,
                });
                setModal(!modal);
            }
        } catch (e) {
            console.log(e);
            setIsLoading(false);
        }
    };

    const onHide = () => {
        setModal(!modal);
        setUserRoleNamesItem({
            userRoleNameID: 0,
            userRoleID: 0,
            designationID: 0,
            roleTitle: "NA",
            active: true,
        });
    };
    const editGridData = (data) => {
        console.log(data);
        setUserRoleNamesItem({
            userRoleNameID: data.userRoleNameID,
            userRoleID: data.userRoleID,
            designationID: data.designationID,
            roleTitle: "NA",//data.roleTitle,
            active: data.active,
        });
        setModal(!modal);
    };

    const deleteGridData = (data) => {
        //setDeleteQuarterItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    };


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }


    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'roleName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end




    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-success mr-2"
                    onClick={() => editGridData(rowData)}
                />
                &nbsp;{" "}
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-warning"
                    onClick={() => deleteGridData(rowData)}
                />
            </>
        );
    };

    const header = (
        <div className="table-header">
            <div className="d-flex justify-content-between">
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                               placeholder="Keyword Search"/>
                </span>
                </div>
                <button
                    type="button"
                    onClick={() => setModal(!modal)}
                    className="btn btn-primary"
                >
                    Add User Wise Role Name
                </button>
            </div>
        </div>
    );
    const footer = `In total there are ${
        state.userRoleNames ? state.userRoleNames.length : 0
    } User Roles.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>;
    };

    const Table = (
        // <DataTable value={user.users} header={header} footer={footer}>
        <DataTable
            value={state.userRoleNames}
            showGridlines
            dataKey="userRoleID" filters={filters1} filterDisplay="menu"
            globalFilterFields={['roleTitle', 'active']}
            header={header}
            footer={footer}
            paginator
            rows={7}
            first={start}
            paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        >
            <Column field="userRoleNameID" header="userRoleNameID" hidden={true}/>
            <Column field="userRoleID" header="userRoleID" hidden={true}/>
            <Column field="roleName" header="Role Type"/>            
            <Column field="designation" header="Role Title"/>
            <Column field="roleTitle" header="Role Title" hidden={true}/>
            <Column field="active" header="Active" body={_isActiveColumn}/>
            <Column
                body={actionBodyTemplate}
                header="Action"
                exportable={false}
                style={{minWidth: "4rem"}}
            />
        </DataTable>
    );

    return (
        <Layout>
            <UserRoleNamesForm
                activeUserRole={activeUserRole}
                designationNames={designationNames}
                isLoading={isLoading}
                userRoleNameID={userRoleNamesItem.userRoleNameID}
                userRoleID={userRoleNamesItem.userRoleID}
                designationID={userRoleNamesItem.designationID}
                active={userRoleNamesItem.active}
                roleTitle={userRoleNamesItem.roleTitle}
                modal={modal}
                onSubmit={onSubmit}
                onHide={onHide}
            />
            {Table}
        </Layout>
    );
};

export default UserRoleNames;
